// ============================================================================
// Types DTO partagés entre frontend et backend.
// Pas de logique métier ici, uniquement des contrats d'API.
//
// IMPORTANT (hygiène source, dette résolue) :
//   Ce fichier EST la source de vérité. Il est compilé vers dist/ par `tsc`
//   (script build du package). Ne plus jamais éditer dist/ à la main : tout
//   type ajouté ici est automatiquement disponible pour apps/server et
//   apps/web, et le `pnpm typecheck` de la CI valide la cohérence.
// ============================================================================
export const USER_ROLES = ['super_admin', 'admin', 'manager', 'agent', 'administre'];
export const USER_SERVICES = [
    'service_technique', 'scolaire_cantine', 'petite_enfance', 'urbanisme', 'associations', 'grc', 'rh', 'comptable',
];
export const SIGNALEMENT_CATEGORIES = [
    { value: 'voirie', label: 'Voirie · chaussée · trottoir' },
    { value: 'espaces_verts', label: 'Espaces verts · arbres' },
    { value: 'eclairage', label: 'Éclairage public' },
    { value: 'proprete', label: 'Propreté · dépôt sauvage' },
    { value: 'assainissement', label: 'Assainissement · eau' },
    { value: 'autre', label: 'Autre' },
];
export const SIGNALEMENT_URGENCES = [
    { value: 'normal', label: 'Normal' },
    { value: 'rapide', label: 'Rapide' },
    { value: 'urgent', label: 'Urgent' },
];
export const SIGNALEMENT_STATUTS = [
    { value: 'recu', label: 'Reçu' },
    { value: 'planifie', label: 'Planifié' },
    { value: 'en_cours', label: 'En cours' },
    { value: 'resolu', label: 'Résolu' },
    { value: 'archive', label: 'Archivé' },
];
/** Libellés FR des origines, pour l'affichage (liste, fiche, exports). */
export const SIGNALEMENT_SOURCES = [
    { value: 'web', label: 'Web' },
    { value: 'mobile', label: 'Mobile' },
    { value: 'accueil_telephone', label: 'Téléphone' },
    { value: 'accueil_guichet', label: 'Guichet' },
    { value: 'email', label: 'Email' },
    { value: 'interne', label: 'Interne' },
];
/** Libellés FR, pour les listes déroulantes et l'affichage. */
export const RH_ABSENCE_TYPES = [
    { value: 'conges_payes', label: 'Congés payés' },
    { value: 'rtt', label: 'RTT' },
    { value: 'maladie', label: 'Arrêt maladie' },
    { value: 'accident_travail', label: 'Accident du travail' },
    { value: 'formation', label: 'Formation' },
    { value: 'enfant_malade', label: 'Enfant malade' },
    { value: 'evenement_familial', label: 'Événement familial' },
    { value: 'sans_solde', label: 'Congé sans solde' },
    { value: 'autorisation_absence', label: 'Autorisation d\'absence' },
    { value: 'autre', label: 'Autre' },
];
export const GRC_PLANNING_TYPES = [
    { value: 'evenement', label: 'Événement' },
    { value: 'publication', label: 'Publication / rédaction' },
    { value: 'captation', label: 'Captation photo / vidéo' },
    { value: 'reseaux_sociaux', label: 'Réseaux sociaux' },
    { value: 'presse', label: 'Relations presse' },
    { value: 'accueil_public', label: 'Accueil du public' },
    { value: 'reunion', label: 'Réunion' },
    { value: 'formation', label: 'Formation' },
    { value: 'autre', label: 'Autre' },
];
export const MENU_TYPES = [
    { value: 'standard', label: 'Standard' },
    { value: 'sans_porc', label: 'Sans porc' },
    { value: 'vegetarien', label: 'Végétarien' },
    { value: 'sans_viande', label: 'Sans viande' },
    { value: 'autre', label: 'Autre' },
];
export const ALLERGENES_INCO = [
    { value: 'gluten', label: 'Gluten' },
    { value: 'crustaces', label: 'Crustacés' },
    { value: 'oeufs', label: 'Œufs' },
    { value: 'poissons', label: 'Poissons' },
    { value: 'arachides', label: 'Arachides' },
    { value: 'soja', label: 'Soja' },
    { value: 'lait', label: 'Lait' },
    { value: 'fruits_a_coque', label: 'Fruits à coque' },
    { value: 'celeri', label: 'Céleri' },
    { value: 'moutarde', label: 'Moutarde' },
    { value: 'sesame', label: 'Sésame' },
    { value: 'sulfites', label: 'Sulfites' },
    { value: 'lupin', label: 'Lupin' },
    { value: 'mollusques', label: 'Mollusques' },
];
export const PAI_STATUTS = [
    { value: 'non_concerne', label: 'Non concerné' },
    { value: 'a_jour', label: 'À jour' },
    { value: 'a_renouveler', label: 'À renouveler' },
];
export const REGIMES_ALIMENTAIRES = [
    { value: 'standard', label: 'Standard' },
    { value: 'sans_porc', label: 'Sans porc' },
    { value: 'sans_viande', label: 'Sans viande' },
    { value: 'vegetarien', label: 'Végétarien' },
    { value: 'autre', label: 'Autre' },
];
export const RESERVATION_STATUTS = [
    { value: 'reserve', label: 'Réservé' },
    { value: 'present', label: 'Présent' },
    { value: 'absent', label: 'Absent' },
    { value: 'absent_justifie', label: 'Absent justifié' },
];
export const PERISCOLAIRE_CRENEAUX = [
    { value: 'matin', label: 'Matin (avant la classe)' },
    { value: 'soir', label: 'Soir (après la classe)' },
];
export const SCOLAIRE_PLANNING_TYPES = [
    { value: 'cantine', label: 'Cantine' },
    { value: 'garderie_matin', label: 'Garderie matin' },
    { value: 'garderie_soir', label: 'Garderie soir' },
    { value: 'alsh', label: 'ALSH' },
    { value: 'sortie', label: 'Sortie' },
    { value: 'reunion', label: 'Réunion' },
    { value: 'formation', label: 'Formation' },
    { value: 'autre', label: 'Autre' },
];
export const SCOLAIRE_PLANNING_PLAGES = [
    { value: 'matin', label: 'Matin', debut: '08:00', fin: '12:00' },
    { value: 'apres_midi', label: 'Après-midi', debut: '13:30', fin: '17:30' },
    { value: 'journee', label: 'Journée continue', debut: '08:00', fin: '17:30' },
    { value: 'libre', label: 'Horaires libres', debut: '', fin: '' },
];
export const DOSSIER_SCOLAIRE_STATUTS = [
    { value: 'brouillon', label: 'Brouillon' },
    { value: 'soumis', label: 'Soumis' },
    { value: 'valide', label: 'Validé' },
    { value: 'refuse', label: 'Refusé' },
    { value: 'en_attente', label: 'En attente de pièces' },
];
export const ASSOCIATION_DOMAINES = [
    { value: 'sport', label: 'Sport' },
    { value: 'culture', label: 'Culture' },
    { value: 'social', label: 'Social / solidarité' },
    { value: 'environnement', label: 'Environnement' },
    { value: 'loisirs', label: 'Loisirs' },
    { value: 'education', label: 'Éducation' },
    { value: 'patrimoine', label: 'Patrimoine' },
    { value: 'sante', label: 'Santé' },
    { value: 'autre', label: 'Autre' },
];
export const REPRESENTANT_FONCTIONS = [
    { value: 'president', label: 'Président·e' },
    { value: 'tresorier', label: 'Trésorier·ère' },
    { value: 'secretaire', label: 'Secrétaire' },
    { value: 'membre', label: 'Membre' },
];
export const TIERS_CATEGORIES_USAGE = [
    { value: 'fournisseur_prestataire', label: 'Fournisseur / prestataire' },
    { value: 'client', label: 'Client' },
    { value: 'organisme_service', label: 'Organisme / service' },
    { value: 'partenaire_editeur', label: 'Partenaire / éditeur' },
    { value: 'beneficiaire', label: 'Bénéficiaire' },
    { value: 'assurance_banque', label: 'Assurance / banque' },
    { value: 'intervenant_expert', label: 'Intervenant / expert' },
];
/* ============================================================================
 * RÉGIME DE TVA DE L'ÉDITEUR — point unique de vérité
 *
 * One For All Distribution relève AUJOURD'HUI de la franchise en base de TVA
 * (art. 293 B du CGI) : aucune taxe ne s'ajoute aux prix hors taxes affichés,
 * qui correspondent donc aux sommes réellement dues.
 *
 * ⚠️ Ce régime est TEMPORAIRE. Il est lié au niveau d'activité de l'éditeur :
 * le franchissement du seuil de franchise entraînera son assujettissement de
 * plein droit à la TVA. Le tarif hors taxes restera inchangé ; la taxe au taux
 * légal s'y ajoutera. Les clients doivent en être informés dès la signature
 * (cf. art. 4.3 des CGV) et au moins 30 jours avant la date d'effet.
 *
 * ⚠️ LE JOUR DU FRANCHISSEMENT DU SEUIL :
 *   → passer FRANCHISE_TVA à false. C'est TOUT.
 *   Les mentions changent partout automatiquement. Les prix HT ne bougent pas.
 *   Ne PAS écrire de mention de TVA en dur ailleurs dans le code.
 *   Voir le récapitulatif RECAP-TVA.md pour les autres points à basculer
 *   (sites statiques notamment, qui ne peuvent pas lire cette constante).
 * ========================================================================== */
/** true tant que l'éditeur relève de la franchise en base (art. 293 B du CGI). */
export const FRANCHISE_TVA = true;
/** Taux de TVA applicable, en pourcentage. 0 sous le régime de franchise. */
export const TAUX_TVA = FRANCHISE_TVA ? 0 : 20;
/** Mention légale portée sur les factures et documents contractuels. */
export const MENTION_TVA = FRANCHISE_TVA
    ? 'TVA non applicable, art. 293 B du CGI'
    : `TVA ${TAUX_TVA} % en sus`;
/** Mention courte affichée sous un tarif dans l'interface. */
export const MENTION_TVA_TARIF = FRANCHISE_TVA
    ? 'TVA non applicable (art. 293 B du CGI) : montant à payer'
    : `Prix HT — TVA ${TAUX_TVA} % en sus`;
/**
 * Avertissement sur le caractère TEMPORAIRE du régime de franchise.
 * Devient vide une fois l'éditeur assujetti : la mention n'a alors plus d'objet.
 * À afficher partout où un tarif est présenté à un prospect ou à un client.
 */
export const MENTION_TVA_EVOLUTION = FRANCHISE_TVA
    ? "L'éditeur relève actuellement de la franchise en base de TVA. La TVA au taux légal s'ajoutera au tarif hors taxes dès son assujettissement, sans modification de ce dernier ; vous en serez informé au moins 30 jours à l'avance."
    : '';
//# sourceMappingURL=index.js.map